export default __webpack_public_path__ + "static/media/lechat-banner.28e81691.png";